export default __webpack_public_path__ + "static/hero-73a993ddb6f4bf068edbaf418e800160.mp4";